import { render } from "./product_promo_code.html?vue&type=template&id=25d2c94c&external"
import script from "./product_promo_code.js?vue&type=script&lang=js&external"
export * from "./product_promo_code.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__